import React from "react";
import {FormattedMessage} from "react-intl";
import {useSnackbar} from "notistack";
import {fetch} from "utils/dataAccess";

// dataAccess.fetch throws on non-2xx with hydra:description as the error
// message; the API sends this stable code when the same action already runs
// on the organization
const ALREADY_RUNNING = 'BATCH_ACTION_ALREADY_RUNNING';

export default function useBatchActionLauncher(onActionLaunched) {
    const { enqueueSnackbar } = useSnackbar();

    return (body) => {
        let headers = new Headers();
        headers.set('Accept', 'application/json');

        fetch("/merchandising/batch", {method: "POST", body: JSON.stringify(body), headers})
            .then(() => {
                enqueueSnackbar(
                    <FormattedMessage id={"merchandising.batch_action.card.success"}/>,
                    {variant: 'success'}
                );
                if (onActionLaunched) {
                    onActionLaunched();
                }
            })
            .catch((error) => {
                const messageId = ALREADY_RUNNING === error.message
                    ? "merchandising.batch_action.card.already_running"
                    : "merchandising.batch_action.card.error";
                enqueueSnackbar(<FormattedMessage id={messageId}/>, {variant: 'error'});
            });
    };
}
